{
  "title": "Stripe & Premium",
  "intro": "Real money, separate from Anima. Stripe data is accessible to owners only.",
  "openStripe": "Open Stripe",
  "configuration": "Stripe configuration",
  "navigation": "Payment management",
  "ready": "Checkout, the customer portal and webhook signing are configured.",
  "setupNeeded": "Configure the offer before opening subscriptions.",
  "setup": "Configure the €3.99 offer",
  "setupConfirm": "This action creates or reuses the €3.99 monthly product, inclusive of applicable taxes, and a portal supporting end-of-period cancellation. It creates no subscription or payment. Make sure the displayed environment is the one you want to configure.",
  "missing": {
    "key": "Stripe server key is missing.",
    "webhook": "Required webhook signing secret: STRIPE_WEBHOOK_SECRET.",
    "price": "Initialize the monthly price or provide STRIPE_PREMIUM_PRICE_ID.",
    "portal": "Initialize the customer portal or provide STRIPE_PORTAL_CONFIGURATION_ID.",
    "activation": "Live payments are not enabled, or a test key is being used in production."
  },
  "mode": {
    "test": "Test environment — no real money",
    "live": "Live Stripe account",
    "unconfigured": "Stripe not configured"
  },
  "tabs": {
    "overview": "Overview",
    "subscriptions": "Subscriptions",
    "payments": "Payments",
    "customers": "Customers",
    "expenses": "Expenses",
    "activity": "Activity"
  },
  "utc": "Reporting periods and expenses use UTC",
  "range": "Reporting period",
  "days_one": "{{count}} day",
  "days_other": "{{count}} days",
  "refresh": "Refresh figures",
  "customers": "ANIDEX customers",
  "customersHint": "Stripe records linked to a game account",
  "activeSubscriptions": "Active subscriptions",
  "paying_one": "{{count}} customer with current paid access",
  "paying_other": "{{count}} customers with current paid access",
  "mrr": "Nominal MRR",
  "mrrHint": "Active × €3.99, before discounts, taxes and incidents",
  "operatingCosts": "Recorded external costs",
  "operatingCostsHint": "Actual costs entered for this period",
  "attention": "{{alerts}} open alerts, {{webhooks}} failed webhooks and {{pastDue}} overdue subscriptions.",
  "inspect": "Review activity",
  "revenueChart": "Receipts, refunds and fees",
  "revenueHint": "Stripe account movements in euros. Other currencies remain separate below.",
  "gross": "Gross receipts",
  "received": "Received",
  "refunds": "Net refunds and reversals",
  "fees": "Stripe fees",
  "net": "After fees and refunds",
  "afterCosts": "After recorded external costs",
  "available": "Available Stripe balance",
  "pending": "Pending Stripe balance",
  "accountingNote": "Receipts and fees come from Stripe balance transactions. Bank payouts are not expenses. Hosting, email and other costs must be entered manually: Stripe does not know them. These indicators are not an accounting profit; reconcile taxes, disputes and other adjustments with Stripe reports. Do not add different currencies together.",
  "canceling_one": "{{count}} renewal is scheduled to stop.",
  "canceling_other": "{{count}} renewals are scheduled to stop.",
  "subscriptionsCaption": "ANIDEX subscriptions synchronized from Stripe. Access depends on the period actually paid for.",
  "paymentsCaption": "Stripe account payments, including one-time purchases and attempts that were not collected.",
  "customersCaption": "Stripe account customers. Unlinked records may be tests or belong to other products.",
  "player": "Player",
  "state": "Status",
  "paidAccess": "Paid period",
  "renewal": "Next renewal",
  "actions": "Actions",
  "suspended": "Access suspended",
  "notPaid": "Not confirmed",
  "canceledRenewal": "Renewal stopped",
  "none": "—",
  "sync": "Resynchronize",
  "cancel": "Stop renewal",
  "resume": "Resume renewal",
  "noSubscriptions": "No ANIDEX subscriptions in this environment",
  "payment": "Payment",
  "refunded": "Refunded",
  "noEmail": "No email provided",
  "receipt": "Receipt",
  "refund": "Refund",
  "noPayments": "No payments in this environment",
  "customer": "Customer",
  "email": "Billing email",
  "created": "Created",
  "openPlayer": "Open player",
  "notLinked": "Not linked to ANIDEX",
  "noCustomers": "No Stripe customers",
  "expensesTitle": "Operating expenses",
  "expensesHint": "Add external costs, not Stripe fees already calculated or bank payouts. Amounts are in euros.",
  "addExpense": "Add expense",
  "expenseLabel": "Description",
  "category": "Category",
  "date": "Payment date",
  "amount": "Amount",
  "amountCurrency": "Amount in {{currency}}",
  "edit": "Edit",
  "delete": "Delete",
  "noExpenses": "No recorded expenses",
  "categories": {
    "infrastructure": "Hosting and storage",
    "email": "Email and communication",
    "other": "Other operating cost"
  },
  "activityHint": "The latest 50 alerts and technical notifications in this environment. Full history and event retries are available in Stripe Workbench.",
  "alerts": "Cases to review",
  "alertsKinds": {
    "refund": "Invoice fully refunded",
    "dispute": "Payment disputed",
    "fraud": "Fraud warning"
  },
  "noAlerts": "No recorded alerts.",
  "resolved": "Reviewed",
  "resolve": "Lift suspension",
  "webhooks": "Stripe synchronization",
  "attempts_one": "{{count}} attempt",
  "attempts_other": "{{count}} attempts",
  "noWebhooks": "No events received. Check the endpoint before opening payments.",
  "retryHint": "Stripe automatically retries failed events. You can also resend events from Workbench. Resynchronizing a subscription rereads its current state without creating a payment.",
  "refundReason": "Refund reason",
  "refundReasons": {
    "requested_by_customer": "Customer request",
    "duplicate": "Duplicate payment",
    "fraudulent": "Fraudulent payment"
  },
  "refundConfirm": "Remaining refundable amount: {{max}}. Check the amount and reason before sending this request to Stripe.",
  "refundWarning": "A refund does not cancel the subscription. A full refund of the current invoice suspends Premium access; also check renewal to avoid another charge.",
  "cancelConfirm": "Renewal will stop at the end of the period. Already-paid access remains available until its normal expiry.",
  "resumeConfirm": "Monthly billing will resume at the next renewal. This action adds no boosters or game resources.",
  "deleteConfirm": "Delete this cost tracking entry? The action will remain in the administration audit log.",
  "resolveWarning": "Lift the suspension only after reviewing the case in Stripe. This may restore access during the remaining paid period; it is neither a refund nor a resolution of the Stripe dispute.",
  "resolutionReason": "Decision reason, at least 10 characters",
  "confirm": {
    "setup": "Configure the Stripe offer",
    "cancel": "Stop this renewal",
    "resume": "Resume this renewal",
    "refund": "Confirm a refund",
    "expense": "Record an expense",
    "deleteExpense": "Delete an expense",
    "resolve": "Review and lift a suspension"
  },
  "confirmAction": "Confirm action",
  "close": "Cancel",
  "saving": "Processing…",
  "saved": "Action recorded",
  "failed": "The action could not be completed",
  "amountInvalid": "Enter a valid positive amount no greater than the remaining refundable balance.",
  "refundDone": "Refund confirmed by Stripe",
  "refundPending": "Refund requested, awaiting confirmation",
  "refundNotConfirmed": "Refund not confirmed: check its Stripe status before trying again",
  "pagination": "Result pages",
  "previous": "Previous",
  "next": "Next",
  "page": "Page {{count}}",
  "status": {
    "active": "Active",
    "trialing": "Trial",
    "past_due": "Overdue",
    "unpaid": "Unpaid",
    "canceled": "Canceled",
    "paused": "Paused",
    "incomplete": "Incomplete",
    "incomplete_expired": "Expired without payment",
    "unsupported": "Unsupported offer",
    "succeeded": "Collected",
    "pending": "Pending",
    "processing": "Processing",
    "requires_payment_method": "Payment method required",
    "requires_action": "Customer action required",
    "requires_confirmation": "Confirmation required",
    "requires_capture": "Capture required",
    "processed": "Synchronized",
    "failed": "Failed"
  }
}
